import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

/** @jsx jsx */
import { jsx } from '@emotion/core';
import MenuGroup from './menu-group';
/**
 * @deprecated
 */

var PopupMenuGroup = function PopupMenuGroup(_ref) {
  var _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? 800 : _ref$maxWidth,
      _ref$minWidth = _ref.minWidth,
      minWidth = _ref$minWidth === void 0 ? 320 : _ref$minWidth,
      rest = _objectWithoutProperties(_ref, ["maxWidth", "minWidth"]);

  return jsx(MenuGroup, _extends({
    maxWidth: maxWidth,
    minWidth: minWidth
  }, rest));
};

export default PopupMenuGroup;